export default "__VITE_ASSET__430e75e7__"